import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [0.59954691494],
    [0.09695898719, 5.06191793158, 529.6909650946],
    [0.00573610142, 1.44406205629, 7.1135470008],
    [0.00306389205, 5.41734730184, 1059.3819301892],
    [0.00097178296, 4.14264726552, 632.7837393132],
    [0.00072903078, 3.64042916389, 522.5774180938],
    [0.00064263975, 3.41145165351, 103.0927742186],
    [0.00039806064, 2.29376740788, 419.4846438752],
    [0.00038857767, 1.27231755835, 316.3918696566],
    [0.00027964629, 1.7845459182, 536.8045120954],
    [0.0001358973, 5.7748104079, 1589.0728952838],
    [0.00008768704, 3.63000308199, 949.1756089698],
    [0.00008246349, 3.5822792584, 206.1855484372],
    [0.00007368042, 5.0810119427, 735.8765135318],
    [0.0000626315, 0.02497628807, 213.299095438],
    [0.00006114062, 4.51319998626, 1162.4747044078],
    [0.00005305441, 4.18625634012, 1052.2683831884],
    [0.00005305285, 1.30671216791, 14.2270940016],
    [0.00004905396, 1.32084470588, 110.2063212194],
    [0.00004647248, 4.69958103684, 3.9321532631],
    [0.00003045023, 4.31676431084, 426.598190876],
    [0.00002609999, 1.56667394063, 846.0828347512],
    [0.00002028191, 1.06376530715, 3.1813937377],
    [0.00001920945, 0.97168196472, 639.897286314],
    [0.00001764763, 2.14148655117, 1066.49547719],
    [0.00001722972, 3.88036268267, 1265.5674786264],
    [0.00001633223, 3.58201833555, 515.463871093],
    [0.00001431999, 4.29685556046, 625.6701923124],
    [0.00000973272, 4.09764549134, 95.9792272178],
    [0.00000884457, 2.43700227469, 412.3710968744],
    [0.00000732853, 6.08535124451, 838.9692877504],
    [0.00000731094, 3.80592308125, 1581.959348283],
    [0.00000709166, 1.2927476033, 742.9900605326],
    [0.00000691971, 6.13365277914, 2118.7638603784],
    [0.00000614482, 4.10850580886, 1478.8665740644],
    [0.00000581903, 4.53969579398, 309.2783226558],
    [0.00000495219, 3.75564106217, 323.5054166574],
    [0.00000440853, 2.95818598959, 454.9093665273],
    [0.00000417267, 1.03554397138, 2.4476805548],
    [0.00000389876, 4.89706786539, 1692.1656695024],
    [0.00000375664, 4.70304250208, 1368.660252845],
    [0.00000341016, 5.7145237931, 533.6231183577],
    [0.00000330458, 4.74049819491, 0.0481841098],
    [0.00000261541, 1.87652515753, 0.9632078465],
    [0.00000261005, 0.82048379203, 380.12776796],
    [0.00000256589, 3.72410394286, 199.0720014364],
    [0.00000244174, 5.22024286247, 728.762966531],
    [0.00000235139, 1.22694468346, 909.8187330546],
    [0.00000220381, 1.65114584814, 543.9180590962],
    [0.00000207336, 1.85463683689, 525.7588118315],
    [0.00000201991, 1.80692992449, 1375.7737998458],
    [0.00000197061, 5.29255821015, 1155.361157407],
    [0.00000175197, 3.22647697998, 1898.3512179396],
    [0.00000175172, 3.7297744122, 942.062061969],
    [0.00000174827, 5.90974976879, 956.2891559706],
    [0.00000157917, 4.36478445901, 1795.258443721],
    [0.00000150504, 3.90624455135, 74.7815985673],
    [0.00000149385, 4.37744775359, 1685.0521225016],
    [0.00000141388, 3.13579930728, 491.5579294568],
    [0.00000137898, 1.31800455202, 1169.5882514086],
    [0.0000013054, 4.16876671917, 1045.1548361876],
    [0.00000117498, 2.50021486074, 1596.1864422846],
    [0.00000116786, 3.3892092106, 0.5212648618],
    [0.00000105894, 4.55439354032, 526.5095713569],
];

const VSOP87_L1: Vsop87Element = [
    [529.69096508814],
    [0.00489503243, 4.2208293947, 529.6909650946],
    [0.00228917222, 6.02646855621, 7.1135470008],
    [0.00030099479, 4.54540782858, 1059.3819301892],
    [0.0002072092, 5.45943156902, 522.5774180938],
    [0.00012103653, 0.16994816098, 536.8045120954],
    [0.00006067987, 4.42422292017, 103.0927742186],
    [0.00005433968, 3.98480737746, 419.4846438752],
    [0.00004237744, 5.89008707199, 14.2270940016],
    [0.00002211974, 5.26766687382, 206.1855484372],
    [0.00001983502, 4.88600705699, 1589.0728952838],
    [0.00001295769, 5.55132752171, 3.1813937377],
    [0.00001174094, 5.84238857133, 1052.2683831884],
    [0.00001163416, 0.51450634873, 3.9321532631],
    [0.0000109873, 5.30705242117, 515.463871093],
    [0.00001007167, 0.46474690033, 735.8765135318],
];

const VSOP87_L2: Vsop87Element = [
    [0.00047233601, 4.32148536482, 7.1135470008],
    [0.00030649436, 2.929777887, 529.6909650946],
    [0.00003189359, 1.05515491122, 522.5774180938],
    [0.00002728901, 4.84555421873, 536.8045120954],
    [0.0000254744, 3.42720888976, 1059.3819301892],
    [0.00001721046, 4.18734600902, 14.2270940016],
    [0.00000383277, 5.76794364868, 419.4846438752],
    [0.00000377503, 0.7605083906, 515.463871093],
    [0.00000367514, 6.05520169517, 103.0927742186],
];

const VSOP87_L3: Vsop87Element = [
    [0.00006501673, 2.5986292365, 7.1135470008],
    [0.00001355012, 1.34692775915, 529.6909650946],
    [0.00000470691, 2.47502798748, 14.2270940016],
];

const VSOP87_L4: Vsop87Element = [[0.00000669505, 0.85280378158, 7.1135470008]];

const VSOP87_L5: Vsop87Element = [];

const VSOP87_B0: Vsop87Element = [
    [0.02268615702, 3.55852606721, 529.6909650946],
    [0.00110090358],
    [0.00109971634, 3.90809347197, 1059.3819301892],
    [0.00008101428, 3.60509572885, 522.5774180938],
    [0.00006437782, 0.30627119215, 536.8045120954],
    [0.00006043996, 4.25883108339, 1589.0728952838],
    [0.0000110688, 2.9853440952, 1162.4747044078],
    [0.00000944328, 1.67522315024, 426.598190876],
    [0.00000941651, 2.93619073963, 1052.2683831884],
    [0.00000894088, 1.75447402715, 7.1135470008],
    [0.00000835861, 5.1788197781, 103.0927742186],
    [0.0000076728, 2.15473604461, 632.7837393132],
    [0.00000684219, 3.67808774854, 213.299095438],
    [0.00000629223, 0.6434329002, 1066.49547719],
    [0.00000558524, 0.01354838161, 846.0828347512],
    [0.00000531671, 2.70305944444, 110.2063212194],
    [0.00000464449, 1.17337267936, 949.1756089698],
    [0.00000431072, 2.6082502278, 419.4846438752],
    [0.00000351433, 4.61062966359, 2118.7638603784],
    [0.00000132159, 4.7781694038, 742.9900605326],
    [0.00000123148, 3.34968047337, 1692.1656695024],
    [0.00000116379, 1.38688268881, 323.5054166574],
    [0.00000115038, 5.04892367391, 316.3918696566],
    [0.00000103762, 3.70104530617, 515.463871093],
    [0.00000103402, 2.31878940535, 1478.8665740644],
    [0.0000010242, 3.15294025567, 1581.959348283],
];

const VSOP87_B1: Vsop87Element = [
    [0.00078203446, 1.52377859742, 529.6909650946],
    [0.00007789905, 2.59734071843, 1059.3819301892],
    [0.00002788602, 4.85622679819, 536.8045120954],
    [0.00002429728, 5.45947255041, 522.5774180938],
    [0.00001985777],
    [0.00000711633, 3.13688338277, 1589.0728952838],
    [0.00000292916, 5.27960297214, 1066.49547719],
    [0.00000271233, 0.10154920958, 7.1135470008],
    [0.00000257804, 4.76667796123, 1052.2683831884],
];

const VSOP87_B2: Vsop87Element = [
    [0.0000549832, 3.01596270062, 529.6909650946],
    [0.00000602076, 3.13358939436, 536.8045120954],
    [0.00000502174, 2.05202111599, 1059.3819301892],
    [0.00000453862, 0.95912416388, 522.5774180938],
    [0.00000115043],
    [0.00000068911, 3.65515676096, 1066.49547719],
];

const VSOP87_B3: Vsop87Element = [
    [0.00000185332, 4.7927676149, 529.6909650946],
    [0.00000085668, 1.40023038638, 536.8045120954],
];

const VSOP87_B4: Vsop87Element = [[0.00000008963, 5.9388723238, 536.8045120954]];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [5.20887429326],
    [0.25209327119, 3.49108639871, 529.6909650946],
    [0.00610599976, 3.84115365948, 1059.3819301892],
    [0.00282029458, 2.57419881293, 632.7837393132],
    [0.00187647346, 2.07590383214, 522.5774180938],
    [0.00086792905, 0.71001145545, 419.4846438752],
    [0.00072062974, 0.21465724607, 536.8045120954],
    [0.00065517248, 5.9799588479, 316.3918696566],
    [0.00030135335, 2.16132003734, 949.1756089698],
    [0.00029134542, 1.67759379655, 103.0927742186],
    [0.00023947298, 0.2745803748, 7.1135470008],
    [0.00023453271, 3.54023522184, 735.8765135318],
    [0.00022283743, 4.19362594399, 1589.0728952838],
    [0.00013032614, 2.96042965363, 1162.4747044078],
    [0.00012749023, 2.71550286592, 1052.2683831884],
    [0.0000970336, 1.90669633585, 206.1855484372],
    [0.00009161393, 4.41352953117, 213.299095438],
    [0.00007894511, 2.47907592482, 426.598190876],
    [0.00007057931, 2.18184839926, 1265.5674786264],
    [0.00006137703, 6.26418240033, 846.0828347512],
    [0.00005477001, 5.65729989857, 639.897286314],
    [0.00004169954, 2.01603822251, 515.463871093],
    [0.00004136822, 2.722208724, 625.6701923124],
    [0.00003502493, 0.56532365822, 1066.49547719],
    [0.00002616976, 2.00994012876, 1581.959348283],
    [0.00002499967, 4.55181655381, 838.9692877504],
    [0.00002127681, 6.12755221002, 742.9900605326],
    [0.00001912009, 0.85621128851, 412.3710968744],
    [0.00001610567, 3.08871452594, 1368.660252845],
    [0.00001479513, 2.68021307468, 1478.8665740644],
    [0.0000123063, 1.89052048109, 323.5054166574],
    [0.00001216895, 1.80176263029, 110.2063212194],
    [0.00001014733, 1.38675822271, 454.9093665273],
    [0.00000998591, 2.87205397992, 309.2783226558],
    [0.00000961113, 4.54876995367, 2118.7638603784],
    [0.00000885764, 4.14783869943, 533.6231183577],
    [0.00000821383, 1.59351544602, 1898.3512179396],
    [0.00000811993, 5.94093410097, 909.8187330546],
    [0.00000776583, 3.67710828843, 728.762966531],
    [0.00000727156, 3.98827252563, 1155.361157407],
    [0.00000655334, 2.7907259691, 1685.0521225016],
    [0.00000654071, 3.38140746852, 1692.1656695024],
    [0.00000620818, 4.82275194351, 956.2891559706],
    [0.0000061474, 2.27633681284, 942.062061969],
];

const VSOP87_R1: Vsop87Element = [
    [0.0127180152, 2.64937512894, 529.6909650946],
    [0.00061661816, 3.00076460387, 1059.3819301892],
    [0.00053443713, 3.89717383175, 522.5774180938],
    [0.00041390269],
    [0.00031185171, 4.88276958012, 536.8045120954],
    [0.00011847263, 2.41328764459, 419.4846438752],
    [0.00009166454, 4.75978553741, 7.1135470008],
    [0.00003403577, 3.34689633223, 1589.0728952838],
    [0.00003203481, 5.21084121495, 735.8765135318],
    [0.00003175595, 2.79298354393, 103.0927742186],
    [0.0000280607, 3.74227009702, 515.463871093],
    [0.00002676611, 4.33051702874, 1052.2683831884],
    [0.00002599925, 3.63439058628, 206.1855484372],
    [0.00002412127, 1.46948314626, 426.598190876],
    [0.00002100392, 3.92772817188, 639.897286314],
    [0.0000164616, 5.30947626153, 1066.49547719],
    [0.00001641093, 4.41628521235, 625.6701923124],
    [0.00001049766, 3.16115576687, 213.299095438],
];

const VSOP87_R2: Vsop87Element = [
    [0.00079644957, 1.35865949884, 529.6909650946],
    [0.00008251645, 5.777744604, 522.5774180938],
    [0.0000702994, 3.27477392111, 536.8045120954],
    [0.00005314031, 1.83835031247, 1059.3819301892],
    [0.00001861184, 2.97686957956, 7.1135470008],
    [0.0000096442, 5.48029587251, 515.463871093],
    [0.00000836256, 4.19892740368, 419.4846438752],
    [0.00000426544, 2.22743958182, 639.897286314],
    [0.00000406408, 3.78248932836, 1066.49547719],
];

const VSOP87_R3: Vsop87Element = [
    [0.00003519277, 6.05800355513, 529.6909650946],
    [0.00001073281, 1.67319166156, 536.8045120954],
    [0.0000091563, 1.41326157617, 522.5774180938],
];

const VSOP87_R4: Vsop87Element = [[0.00000128623, 0.08347608895, 536.8045120954]];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
